import { Typography } from "@mui/material"
import styles from "./DataCard.module.css"

type DataCardProps = {
    title: string,
    number: number,
    icon: React.ReactNode, 
}

export default function DataCard({title, number, icon}: DataCardProps){

    return(
        <div className={styles.card}>
            <div>
                <Typography className={styles.title}>{title}</Typography>
                <Typography className={styles.number}>{number}</Typography>
            </div>
            {icon}
        </div>
    )
}